import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import {
  ObjectStoreObjectFilters,
  ObjectStoreObjectSearchRequestProvider,
  ObjectStoreObjectTable,
} from "./components/ObjectStoreObjectTable";

export function ObjectStoreObjectsPage() {
  return (
    <TablePage
      title="Search Objects"
      navigation={<LqsNavigation />}
      RequestProvider={ObjectStoreObjectSearchRequestProvider}
      table={
        <>
          <DataStoreBreadcrumbs />
          <ObjectStoreObjectTable />
        </>
      }
      filters={<ObjectStoreObjectFilters />}
    />
  );
}
